import './form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import InputField from '../../shared/form-elements/input';
import SelectField from '../../shared/form-elements/select/field';
import CheckboxField from '../../shared/form-elements/checkbox';
import UploadField from '../../shared/form-elements/upload';

import SettingsForm from './settings/main';
import Textarea from '../../shared/form-elements/textarea';

const isEverad = process.env.CPA_ENV === 'everad';

const Form = ({
	handleSubmit,
	pristine,
	submitting,
	langSelectOptions,
	loadRegionsLookup,
	adminRoles,
	timezoneOptions,
	submitForm,
	loadAffiliatesLookup,
	editId,
	preparationFile,
	intl,
	can,
	loadAdminsLookup,
	isProfile,
	timezonesLookup
}) => (
	<div className="form-container admins-form">
		<div className="form-container__head">
			<h2>{ intl(!editId ? isProfile ? 'Edit profile' : 'Create new admin' : 'Edit admin') }</h2>
		</div>

		<div className="form-container__body">
			<form className="ui-form create-admin" onSubmit={handleSubmit(data => submitForm(data, editId))}>

				<div className="ui-form__element">
					<Field
						name="avatar"
						component={UploadField}
						placeholder={ intl('Upload avatar') }
						preparationFile={preparationFile}
					/>
				</div>

				<div className="ui-form__element">
					<Field name="name" placeholder={ intl('Name') } component={InputField} />
				</div>

				<div className="ui-form__element">
					<Field name="email" placeholder={ intl('Email') } component={InputField} />
				</div>

				<div className="ui-form__element">
					<Field name="skype" placeholder={ intl('Skype') } component={InputField} />
				</div>

				<div className="ui-form__element">
					<Field name="telegram" placeholder={ intl('Telegram') } component={InputField} />
				</div>

				<div className="ui-form__element">
					<Field
						name="manager_tg_id"
						placeholder={ intl('Telegram id') }
						component={InputField}
						type="number"
					/>
				</div>

				<div className="ui-form__element">
					<Field name="password" placeholder={ intl('Password') } component={InputField} type="password"/>
				</div>

				{!isProfile && <div className="ui-form__element">
					<Field
						name="role"
						searchable={false}
						placeholder={ intl('Role') }
						component={SelectField}
						options={adminRoles} />
				</div>}

				{!isProfile && <div className="ui-form__element">
					<Field
						name="languages"
						searchable={false}
						placeholder={ intl('Languages') }
						multi={true}
						component={SelectField}
						options={langSelectOptions}  />
				</div>}

				{!isProfile && <div className="ui-form__element">
					<Field
						name="is_manager"
						placeholder={ intl('Incoming reg') }
						normalize={v => !!v }
						component={CheckboxField} />
				</div>}

				{!isProfile && isEverad && <div className="ui-form__element">
					<Field
						name="regions"
						searchable={false}
						placeholder={ intl('Regions') }
						multi={true}
						component={SelectField}
						options={loadRegionsLookup}  />
				</div>}

				{!isProfile && <div className="ui-form__element">
					<Field
						name="is_full_capacity"
						placeholder={ intl('Is Full Capacity') }
						normalize={v => !!v }
						component={CheckboxField} />
				</div>}

				<div className="ui-form__element">
					<Field
						name="is_only_own_affiliates"
						placeholder={ intl('Show only own affiliates') }
						normalize={v => !!v }
						component={CheckboxField} />
				</div>

				{!isProfile && <div className="ui-form__element">
					<Field
						name="is_restricted"
						placeholder={ intl('Restrict lists') }
						normalize={v => !!v }
						component={CheckboxField} />
				</div>}

				{!isProfile && <div className="ui-form__element">
					<Field
						name="substituting_ids"
						searchable={true}
						placeholder={ intl('Substituting managers') }
						multi={true}
						component={SelectField}
						options={loadAdminsLookup}  />
				</div>}

				{!isProfile && <div className="ui-form__element">
					<Field
						name="sub_ids"
						searchable={true}
						placeholder={ intl('Subordinate admins') }
						multi={true}
						component={SelectField}
						options={loadAdminsLookup}  />
				</div>}

				{!isProfile && <div className="ui-form__element">
					<Field
						name="allowed_affiliate_ids"
						searchable={true}
						placeholder={ intl('Allowed affiliate ids') }
						multi={true}
						component={SelectField}
						options={loadAffiliatesLookup}  />
				</div>}

				<div className="ui-form__element">
					<Field
						name="desired_real_approves_count"
						placeholder={ intl('CRM Approves Per Month (Plan)') }
						component={InputField}
						type="number"
					/>
				</div>

				<div className="ui-form__element">
					<Field
						name="timezone"
						placeholder={ intl('Timezone') }
						multi={false}
						component={SelectField}
						options={timezonesLookup}  />
				</div>

				<div className='ui-form__element display-inline-block width-100-p'>
					<Field
						name="config"
						component={Textarea}
						placeholder={ intl('Conofig') }
						showLabel={true}
					/>
				</div>

				<div className="ui-form__element buttons">
					{(isProfile || can('edit')) &&
						<button className="ui-btn ui-btn-primary">
							{intl(!editId ? 'Save' : 'Edit')}
						</button>}
					{!isProfile && <Link to="admins/">
						<button type="button" className="ui-btn ui-btn-cancel">
							{intl('Cancel')}
						</button>
					</Link>}
				</div>
			</form>
			<SettingsForm />
		</div>
	</div>
);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	pristine: PropTypes.bool,
	langSelectOptions: PropTypes.array,
	permissionsSelectOptions: PropTypes.array,
	timezoneOptions: PropTypes.array,
	submitting: PropTypes.bool,
	submitForm: PropTypes.func,
	preparationFile: PropTypes.func,
	editId: PropTypes.any,
	intl: PropTypes.func,
	can: PropTypes.func,
	loadAdminsLookup: PropTypes.func,
	isProfile: PropTypes.bool,
	timezonesLookup: PropTypes.func
};

const validate = values => {
	const errors = {};
	if (values.is_manager && !values.telegram) {
		errors.telegram = 'Telegram is required for managers';
	}
	return errors;
};

export default reduxForm({
	form: 'adminsForm',
	validate
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/form.js